import { configureStore } from '@reduxjs/toolkit'
// import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'; // this uses sessionStorage

import { persistReducer } from "redux-persist"
import { combineReducers } from "@reduxjs/toolkit"
import loginapi from '../Slices/LoginRedux/loginSlices';
import ReduxLocalSlice from '../Slices/CommonLocalRedux/NavigationSlice'
import Authenticationslice from '../Slices/AuthenticationRedux/AuthenticationToken'
import CommonLocalSlice from '../Slices/CommonLocalRedux/CommonSliceStorage'

// Screener Redux import

import ScreenerCommonSlice from '../Slices/ScreenerRedux/CommonReduxSlices/ScreenerCommonSlice'
import FilterRowCount from '../Slices/ScreenerRedux/FilterRowManagement/FilterRowCount'
import FilterSaveData from '../Slices/ScreenerRedux/FilteSaveRedux/FilterSaveData'
import FilterCheckBox from '../Slices/ScreenerRedux/FilterCheckBoxSlices/FilterCheckBox'
import OutputCombineData from '../Slices/ScreenerRedux/OutputReduxSlice/OutputSlice'
import radioButtonSlice from "../Slices/ScreenerRedux/FilterConsolidatedata/ConsoliadtedData";
import TPScreenerSlice from '../Slices/TPScreener/TPScreenerSlice';
const persistConfig = {
  key: "root",
  version: 1,
  storage: storageSession, // ✅ correct key here
}

const reducer = combineReducers({
  Authenticationapi: Authenticationslice,
  LoginUserDetails: loginapi,
  Navigation: ReduxLocalSlice,
  LocalValuesData: CommonLocalSlice,

  // Screener Reducer

  Screenercommon: ScreenerCommonSlice,
  ScreenerFilterRowCount: FilterRowCount,
  FilterSaveData: FilterSaveData,
  FilterCheckBox: FilterCheckBox,
  ScreenerOutpuSlice:  OutputCombineData,
  radioButtonSlice:radioButtonSlice,
  Tpscreener: TPScreenerSlice

})
const persistedReducer = persistReducer(persistConfig, reducer)

const Store = configureStore({
  reducer: persistedReducer
})



export default Store